<template>
  <div class="home-container">
    <div class="top-container">
      <HomeHeader class="top-header"></HomeHeader>
      <template v-if="bannerList.length">
        <HomeBannerSwiper :list="bannerList" :key="swiperKey"></HomeBannerSwiper>
      </template>
    </div>
    <main>
      <HomeNews :lastNewsList="lastNewsList" :noticeList="noticeList"></HomeNews>
      <HomeAgency></HomeAgency>
      <HomeStudy :sudiList="sudiList" :qikanList="qikanList"></HomeStudy>
      <HomeActivity :yugaoList="yugaoList" :qianyanList="qianyanList"></HomeActivity>
      <HomeExpert :expertList="expertList"></HomeExpert>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";
import { bannerFinds } from "@/api/common/banner";

import HomeHeader from "@/components/common/header";
import HomeNews from "./homeNews";
import HomeBannerSwiper from "./homeBannerSwiper";
import HomeAgency from "./homeSwiperAgency";
import HomeStudy from "./homeStudy";
import HomeActivity from "./homeActivity";
import HomeExpert from "./homeExpert";
import Footer from "@/components/common/footer";
export default {
  name: "Home",
  components: { HomeHeader, HomeBannerSwiper, HomeNews, HomeAgency, HomeStudy, HomeActivity, HomeExpert, Footer },
  data() {
    return {
      contentBean: {
        type1: "",
        home: "是",
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        sort: "priority, publish_time",
        order: "desc"
      },
      lastNewsList: [], // 最新动态
      noticeList: [], // 通知公告
      sudiList: [], // 学术著作
      qikanList: [], // 期刊论文
      yugaoList: [], // 活动预告
      qianyanList: [], // 前沿观点
      expertList: [], // 专家学者
      bannerList: [],
      mobileWidth: false,
      swiperKey: 0
    };
  },
  beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber)
  },
  watch: {
    mobileWidth: {
      handler() {
        if (this.mobileWidth) {
          this.bannerList.forEach(item => {
            item.imgUrl = item.imageMobile;
          });
          this.swiperKey++;
        } else {
          this.bannerList.forEach(item => {
            item.imgUrl = item.image;
          })
          this.swiperKey++;
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.setVisibleNumber();

    this.getBannerList().then(res => {
      this.bannerList = res.list;
      if (this.mobileWidth) {
        this.bannerList.forEach(item => {
          item.imgUrl = item.imageMobile;
        })
      } else {
        this.bannerList.forEach(item => {
          item.imgUrl = item.image;
        })
      }
    });
    this.getData({ contentBean: { type1: "最新动态", home: "是" }, pageSize: 2 }).then(res => {
      this.lastNewsList = res.list;
    });
    this.getData({ contentBean: { type1: "通知公告", home: "是" }, pageSize: 6 }).then(res => {
      this.noticeList = res.list;
    });
    this.getData({ contentBean: { type1: "学术著作", home: "是" }, pageSize: 2 }).then(res => {
      this.sudiList = res.list;
    });
    this.getData({ contentBean: { type1: "期刊论文", home: "是" }, pageSize: 4 }).then(res => {
      this.qikanList = res.list;
    });
    this.getData({ contentBean: { type1: "活动预告", home: "是" }, pageSize: 3 }).then(res => {
      this.yugaoList = res.list;
    });
    this.getData({ contentBean: { type1: "前沿观点", home: "是" }, pageSize: 4 }).then(res => {
      this.qianyanList = res.list;
    });
    this.getData({ contentBean: { type1: "专家学者", home: "是", type2: "本院学者" }, pageSize: 99 }).then(res => {
      this.expertList = res.list;
    });
  },
  methods: {
    setVisibleNumber() {
      const width = document.body.getBoundingClientRect().width;
      this.mobileWidth = parseInt(width) <= 768;
    },
    // 请求数据
    getData(params) {
      let data = Object.assign({}, this.pageParams, { contentBean: this.contentBean }, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data);
        }
      })
    },
    getBannerList() {
      return new Promise(async (resolve, reject) => {
        const res = await bannerFinds({
          "pageSize": 10,
          "pageNumber": 1,
          "sort": "priority",
          "order": "asc"
        });
        if (res.status == 200) {
          resolve(res.data);
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .top-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 37.5%;
    .top-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
  .home-container {
    .top-container {
      padding-bottom: 44%;
    }
  }
}

@media screen and (max-width: 768px) {
  .home-container {
    .top-container {
      padding-bottom: 60%;
    }

    main {
      padding: 0 14px;
    }
  }
}
</style>
